import CampaignPage from "./webstore/campaign";
import AllCampaignsPage from "./webstore/campaign/all";
import CheckoutPage from "./webstore/checkout";
import CartPage from "./webstore/checkout/cart";
import ErrorPage from "./error";
import ProductDetailPage from "./webstore/product";
import AllProductsPage from "./webstore/product/all";
import WebStoreHome from "./webstore/home";
import CampaignCheckout from "./web_link";
import StoreFront from "./web_link/store";
import SmmShare from "./smm";
import AgentProductPage from "./web_link/product";
import BuyPage from "./web_link/product/checkout";
import TikTokApprovalPage from "./smm/tiktok";
import InstagramApprovalPage from "./smm/instagram";
import SmmPostContent from "./smm/upload";
import DataCapturePage from "./data_capture";
import CampaignWindowPage from "./campaign_view";
import InstagramInsightsApprovalPage from "./smm/ig_metrics";
import SmmProfileLinkingPage from "./smm/profile_links";
import SmmOrganisationProfileLinkingPage from "./smm/profile_links/organisation";
import InstagramInsightsApprovalAuthPage from "./smm/ig_auth";
import SmmCampaignReviewPage from "./smm/review";

const appRoutes = [
  {
    name: "WebStore",
    key: "webstore-home",
    route: "/ws/:ref",
    component: <WebStoreHome />,
    secure: false,
  },
  {
    name: "Campaign",
    key: "campaigns",
    route: "/ws/categories/:ref",
    component: <AllCampaignsPage />,
    secure: false,
  },
  {
    name: "Campaign",
    key: "campaign",
    route: "/ws/category/:ref",
    component: <CampaignPage />,
    secure: false,
  },
  {
    name: "Products",
    key: "products",
    route: "/ws/products/:ref",
    component: <AllProductsPage />,
    secure: false,
  },
  {
    name: "Product Details",
    key: "product-detail",
    route: "/ws/product/:ref",
    component: <ProductDetailPage />,
    secure: false,
  },
  {
    name: "Cart Page",
    key: "cart",
    route: "/ws/cart/:ref",
    component: <CartPage />,
    secure: false,
  },
  {
    name: "Checkout Page",
    key: "checkout",
    route: "/ws/checkout/:ref",
    component: <CheckoutPage />,
    secure: false,
  },
  {
    name: "Campaign Page",
    key: "campaign-checkout",
    route: "/checkout/:ref",
    component: <CampaignCheckout />,
    secure: false,
  },
  {
    name: "Paylink",
    key: "campaign-checkout-pv",
    route: "/pv/:ref",
    component: <CampaignCheckout />,
    secure: false,
  },
  {
    name: "DataCapture",
    key: "data-capture",
    route: "/data/:ref",
    component: <DataCapturePage />,
    secure: false,
  },
  {
    name: "StoreFront",
    key: "store-front",
    route: "/i/:ref",
    component: <StoreFront />,
    secure: false,
  },
  {
    name: "SmmShare",
    key: "sm-share",
    route: "/share/:ref",
    component: <SmmShare />,
    secure: false,
  },
  {
    name: "Agent Product Page",
    key: "agent-product",
    route: "/p/:agentRef/:ref",
    component: <AgentProductPage />,
    secure: false,
  },
  {
    name: "Product Buy Page",
    key: "agent-product-buy",
    route: "/p/checkout",
    component: <BuyPage />,
    secure: false,
  },
  {
    name: "TikTok Page",
    key: "tiktok-app",
    route: "/sm/tiktok/:ref/:code",
    component: <TikTokApprovalPage />,
    secure: false,
  },
  {
    name: "Instagram Page",
    key: "ig-app",
    route: "/sm/instagram/:ref/:code",
    component: <InstagramApprovalPage />,
    secure: false,
  },
  {
    name: "Instagram Page",
    key: "ig-app",
    route: "/sm/instagram/insights/auth",
    component: <InstagramInsightsApprovalAuthPage />,
    secure: false,
  },
  {
    name: "Instagram Page",
    key: "ig-app",
    route: "/sm/instagram/insights",
    component: <InstagramInsightsApprovalPage />,
    secure: false,
  },
  {
    name: "SMM Upload Page",
    key: "smm-upload",
    route: "/sm/upload/:ref",
    component: <SmmPostContent />,
    secure: false,
  },
  {
    name: "Campaign Window",
    key: "campaign-window",
    route: "/wnd/:ref",
    component: <CampaignWindowPage />,
    secure: false,
  },
  {
    name: "Profile Linking",
    key: "smm-account-profile-link",
    route: "/sm/link/:ref",
    component: <SmmProfileLinkingPage />,
    secure: false,
  },
  {
    name: "Profile Linking",
    key: "smm-organisation-profile-link",
    route: "/sm/organisation/link/:ref",
    component: <SmmOrganisationProfileLinkingPage />,
    secure: false,
  },
  {
    name: "Review",
    key: "smm-review",
    route: "/sm/review/:ref",
    component: <SmmCampaignReviewPage />,
    secure: false,
  },
  {
    name: "Error Page",
    key: "error",
    route: "/error",
    component: <ErrorPage />,
    secure: false,
  },
];

export default appRoutes;
